<script>
// Extensions
import View from "@/views/home/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Shipper",

  metaInfo: { title: "Shipper" },

  extends: View,

  mixins: [
    LoadSections([
      "hero-alt",
      // "about-our-product",
      "theme-features",
      // "affiliates",
      // "newsletter",
      "pro-features",
      "info",
    ]),
  ],

  props: {
    id: {
      type: String,
      default: "about",
    },
  },
};
</script>
